var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialmedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M17 15C16.4477 15 16 15.4477 16 16C16 16.5523 16.4477 17 17 17C17.5523 17 18 16.5523 18 16C18 15.4477 17.5523 15 17 15ZM15 16C15 14.8954 15.8954 14 17 14C18.1046 14 19 14.8954 19 16C19 17.1046 18.1046 18 17 18C15.8954 18 15 17.1046 15 16Z",
    fill: "black",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M7 5C6.44772 5 6 5.44772 6 6C6 6.55228 6.44772 7 7 7C7.55228 7 8 6.55228 8 6C8 5.44772 7.55228 5 7 5ZM5 6C5 4.89543 5.89543 4 7 4C8.10457 4 9 4.89543 9 6C9 7.10457 8.10457 8 7 8C5.89543 8 5 7.10457 5 6Z",
    fill: "black",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M17.0005 18C15.4291 18 14.0983 19.036 13.6564 20.4635L12.7012 20.1677C13.269 18.3334 14.9784 17 17.0005 17C19.0227 17 20.7321 18.3334 21.2999 20.1677L20.3447 20.4635C19.9028 19.036 18.572 18 17.0005 18Z",
    fill: "black",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M7.00055 8C5.42911 8 4.09834 9.036 3.65645 10.4635L2.70117 10.1677C3.26902 8.33341 4.97841 7 7.00055 7C9.02269 7 10.7321 8.33341 11.2999 10.1677L10.3447 10.4635C9.90276 9.036 8.57199 8 7.00055 8Z",
    fill: "black",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M17 12.5C14.5147 12.5 12.5 14.5147 12.5 17C12.5 19.4853 14.5147 21.5 17 21.5C19.4853 21.5 21.5 19.4853 21.5 17C21.5 14.5147 19.4853 12.5 17 12.5ZM11.5 17C11.5 13.9624 13.9624 11.5 17 11.5C20.0376 11.5 22.5 13.9624 22.5 17C22.5 20.0376 20.0376 22.5 17 22.5C13.9624 22.5 11.5 20.0376 11.5 17Z",
    fill: "black",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M7 2.5C4.51472 2.5 2.5 4.51472 2.5 7C2.5 9.48528 4.51472 11.5 7 11.5C9.48528 11.5 11.5 9.48528 11.5 7C11.5 4.51472 9.48528 2.5 7 2.5ZM1.5 7C1.5 3.96243 3.96243 1.5 7 1.5C10.0376 1.5 12.5 3.96243 12.5 7C12.5 10.0376 10.0376 12.5 7 12.5C3.96243 12.5 1.5 10.0376 1.5 7Z",
    fill: "black",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6 15.5C5.17157 15.5 4.5 16.1716 4.5 17C4.5 17.8284 5.17157 18.5 6 18.5C6.82843 18.5 7.5 17.8284 7.5 17C7.5 16.1716 6.82843 15.5 6 15.5ZM3.5 17C3.5 15.6193 4.61929 14.5 6 14.5C7.38071 14.5 8.5 15.6193 8.5 17C8.5 18.3807 7.38071 19.5 6 19.5C4.61929 19.5 3.5 18.3807 3.5 17Z",
    fill: "black",
    fillRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M18 5.5C18.8284 5.5 19.5 6.17157 19.5 7C19.5 7.82843 18.8284 8.5 18 8.5C17.1716 8.5 16.5 7.82843 16.5 7C16.5 6.17157 17.1716 5.5 18 5.5ZM20.5 7C20.5 5.61929 19.3807 4.5 18 4.5C16.6193 4.5 15.5 5.61929 15.5 7C15.5 8.38071 16.6193 9.5 18 9.5C19.3807 9.5 20.5 8.38071 20.5 7Z",
    fill: "black",
    fillRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8 16.5H12V17.5H8V16.5Z",
    fill: "black",
    fillRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16 6.5H12V7.5H16V6.5Z",
    fill: "black",
    fillRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10.8536 10.1464L13.8536 13.1464L13.1465 13.8536L10.1465 10.8536L10.8536 10.1464Z",
    fill: "black",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialmedia);
export default __webpack_public_path__ + "static/media/socialmedia.8f3fbd649c8a19dc4370e0c8b813f1bc.svg";
export { ForwardRef as ReactComponent };